export const InfoVersion = [
  {
    version: "3.28.1",
    create_day: "21/02/2025",
    new_feature: [],
    fix_bug: [
      {
        content: "fix: handle crash page when data type invalid",
      },
    ],
  },
  {
    version: "3.28.0",
    create_day: "19/02/2025",
    new_feature: [
      {
        content: "feat: release sales module",
      },
    ],
    fix_bug: [
      {
        content: "fix: update Monaco VS",
      },
      {
        content: "fix: show multi-detail data",
      },
      {
        content: "fix: check description display on internet form",
      },
    ],
  },
  {
    version: "3.27.2",
    create_day: "15/01/2025",
    new_feature: [],
    fix_bug: [
      {
        content: "fix: update css layout horizontal ticket",
      },
      {
        content: "fix: [ModalRecord] search assign to",
      },
      {
        content: "fix: [Lib] update dompurify",
      },
      {
        content: "fix: add a minimum height for the third-party table",
      },
      {
        content: "fix: handle redirection from the Kanban view",
      },
    ],
  },
  {
    version: "3.27.1",
    create_day: "08/01/2025",
    new_feature: [],
    fix_bug: [
      {
        content: "fix: config split chunk files",
      },
    ],
  },
  {
    version: "3.27.0",
    create_day: "03/01/2025",
    new_feature: [
      {
        content: "feat: [EmailTemplate] add append fields droplist",
      },
    ],
    fix_bug: [
      {
        content: "fix: change notification error timeout to 10s",
      },
      {
        content: "fix: hide null section in modalRecord",
      },
      {
        content: "fix: move main list fields object to the top",
      },
      {
        content: "fix: handle sync 3rd in call center",
      },
    ],
  },
  {
    version: "3.26.0",
    create_day: "06/12/2024",
    new_feature: [
      {
        content: "feat: improvement slug in knowledge base",
      },
      {
        content: "feat: Add a GUID to the text field.",
      },
      {
        content:
          "feat: Display report details when double clicking on a widget.",
      },
      {
        content:
          "feat: Open tab consolidated view in the report detail and support report pagination.",
      },
      {
        content: "feat: add script CTI",
      },
      {
        content: "feat: add a new duplicated rules",
      },
      {
        content: "refactor: HS512",
      },
    ],
    fix_bug: [
      {
        content: "fix: Display id user in linking field user",
      },
    ],
  },
  {
    version: "3.25.0",
    create_day: "18/11/2024",
    new_feature: [
      {
        content: "feat: add a new cti setting",
      },
    ],
    fix_bug: [
      {
        content: "fix: SITE KEY in internet form",
      },
      {
        content: "fix: update UI component multi detail",
      },
      {
        content: "fix: fix droplist dependency when mass editing records",
      },
      {
        content: "fix: change the path for the Monaco Editor",
      },
    ],
  },
  {
    version: "3.24.1",
    create_day: "05/11/2024",
    new_feature: [],
    fix_bug: [
      {
        content: "fix: remove the retry mechanism for the WebSocket",
      },
    ],
  },
  {
    version: "3.24.0",
    create_day: "24/10/2024",
    new_feature: [
      {
        content:
          "feat: [CallCenter] add layout 4; handle double click contact list (ISS107123)",
      },
      {
        content: "feat: Improvement internet form (ISS112594)",
      },
      {
        content: "feat: time range filter in workflow schedule",
      },
      {
        content: "feat: update UI component multi detail",
      },
      {
        content: "feat: archived data for interaction",
      },
      {
        content: "feat: allow sorting the droplist (ISS100533)",
      },
      {
        content: "feat: For sale",
      },
    ],
    fix_bug: [
      {
        content:
          "fix: Load ra data các field droplist khi nhập email theo gợi nhớ (ISS100571)",
      },
      {
        content: "fix: logs staging (ISS100594)",
      },
      {
        content:
          "fix: Allow search field type droplist in component Case history (ISS101675)",
      },
      {
        content: "fix: Search group in modal share view",
      },
    ],
  },
  {
    version: "3.23.0",
    create_day: "04/10/2024",
    new_feature: [],
    fix_bug: [
      {
        content: "fix: [Email] remove class of email (ISS100548)",
      },
      {
        content: "fix: [CallCenter] improve CORE search flow (ISS100492)",
      },
      {
        content:
          "fix: [Report-QuickFilter] can not save quick filter (ISS100568)",
      },
      {
        content: "fix: allow upload multi images on email editor",
      },
      {
        content:
          "fix: Load ra data các field droplist khi nhập email theo gợi nhớ (ISS100571)",
      },
    ],
  },
  {
    version: "3.22.0",
    create_day: "13/09/2024",
    new_feature: [
      {
        content: "feat: [Finesse] add display custom fields",
      },
      {
        content: "feat: change UI dialpad",
      },
      {
        content:
          "feat: khi bấm xem noti của Object Article hệ thống sẽ điều hướng sang trang detail Article (BUCRM-3065)",
      },
      {
        content: "feat: Improvement component staging",
      },
      {
        content: "feat: Allow search time range in component case history",
      },
      {
        content:
          "feat: Bổ sung cấu hình trong Object để bật/tắt sử dụng custom view khi search global",
      },
      {
        content: "feat: check VIP customer on multi detail",
      },
    ],
    fix_bug: [
      {
        content: "fix: [Email] split cc email (BUCRM-3043)",
      },
      {
        content: "fix: move agent monitor to sidebar",
      },
      {
        content: "fix: update check require field linking (BUCRM-3072)",
      },
      {
        content: "fix: clear cache get user asign to when log out",
      },
    ],
  },
  {
    version: "3.21.0",
    create_day: "22/08/2024",
    new_feature: [
      {
        content:
          "feat: bổ sung nguồn gốc của các thao tác create update khi xem Log UCRM-3701",
      },
      {
        content: "feat: Đổi tên Custom Report thành Multi-factor Report",
      },
      {
        content:
          "feat :Apply cấu hình highlight trong component ticket history",
      },
      {
        content:
          "feat: [ExposeAPICheck] add multiple and/or conditions (UCRM-3696)",
      },
      {
        content: "feat: [Report] add collapse description report (UCRM-2523)",
      },
      {
        content:
          "feat: [Action Workflow] allow customize request body action Call API (UCRM-3687)",
      },
      {
        content:
          "feat: [Report] add sort report summary and row summary (UCRM-3689)",
      },
      {
        content: "feat: add button base app (UCRM-3621)",
      },
      {
        content: "feat: change primary color of app (UCRM-3705)",
      },
    ],
    fix_bug: [
      {
        content:
          "fix: lỗi hiển thị thông tin trên field Text Area trên Component Multi detail contact BUCRM-3028",
      },
      {
        content:
          "fix: type of action chưa hiển thị các type update cấu hình trong system log BUCRM-3027",
      },
      {
        content:
          "fix: tối ưu lại giao diện của component Case History BUCRM-3041",
      },
      {
        content: "fix: add component id when link interaction (Case history)",
      },
      {
        content: "fix: change link export report history",
      },
      {
        content:
          "fix: [CallCenter] add key to sync in list of contacts (BUCRM-3015)",
      },
      {
        content: "fix: add retry websocket (UCRM-3492)",
      },
      {
        content: "fix: [Dashboard] display user id in report (BUCRM-3024)",
      },
      {
        content:
          "fix: fix load dynamic field modal record of consolidated view (BUCRM-3036)",
      },
      {
        content: "fix: paste img to editor (BUCRM-3030)",
      },
      {
        content: "fix: add default value for number field (BUCRM-3033)",
      },
      {
        content:
          "fix: allow setting field droplist update fields on Dynamic button(BUCRM-3044)",
      },
      {
        content: "fix: show droplist label when merge record (BUCRM-3045)",
      },
    ],
  },
  {
    version: "3.20.0",
    create_day: "01/08/2024",
    new_feature: [
      {
        content: "feat: duplicate bản ghi (UCRM-3434)",
      },
      {
        content:
          "feat: add component timeline and case history on target contact (UCRM-3485)",
      },
    ],
    fix_bug: [
      {
        content: "fix: use droplist default in modal create CASE (BUCRM-2980)",
      },
      {
        content: "fix: [Callcenter] external app integration (BUCRM-2982)",
      },
    ],
  },
  {
    version: "3.19.0",
    create_day: "25/07/2024",
    new_feature: [
      {
        content:
          "Improvement: Khi search CORE ở component Multi details, thì sẽ search dữ liệu ở cả UCRM (UCRM-3477)",
      },
      {
        content:
          "Improvement: Thêm key để đồng bộ dữ liệu ở CORE trong component Multi details (UCRM-3478)",
      },
      {
        content: "Improvement: Add permissions using the Share To (UCRM-3424)",
      },
      {
        content:
          "Improvement: Add phone field option for SMS Action (UCRM-3428)",
      },
      {
        content:
          "Improvement: Add field sharing to in email/notification workflow (UCRM-3469)",
      },
    ],
    fix_bug: [
      {
        content: "fix: bug clear value parent droplist (BUCRM-2970)",
      },
    ],
  },
  {
    version: "3.18.0",
    create_day: "18/07/2024",
    new_feature: [
      {
        content:
          "Improvement: Action send SMS: cho phép chọn nhiều số điện thoại ở field Gửi đến trong Action send SMS, nếu không chọn field Số điện thoại ở field Gửi đến, mặc định sẽ gửi tới SDT cấu hình trong SMS outgoing",
      },
      {
        content:
          "Improvement: Thay đổi template Popup Call số 3 theo tỉ lệ 45 : 35 : 25",
      },
      {
        content:
          "Improvement: Tối ưu layout Popup call, config component CORE details ẩn hiện theo data ở template số 3",
      },
    ],
    fix_bug: [],
  },
  {
    version: "3.17.0",
    create_day: "12/07/2024",
    new_feature: [
      {
        content:
          "feat: add option label of droplist in action call API - workflow and Dynamic Button (UCRM-3417)",
      },
    ],
    fix_bug: [],
  },

  {
    version: "3.16.0",
    create_day: "05/07/2024",
    new_feature: [
      {
        content:
          "feat: Điều chỉnh giao diện Component Case history từ Timeline sang dạng Nested table(UCRM-3318)",
      },
      {
        content: "feat: Bổ sung birthday trên màn hình search core (UCRM-3415)",
      },
      {
        content: "feat: add new layout (03) callview",
      },
      {
        content: "feat: Tối ưu luồng xác định khách hàng của luồng Call",
      },
      {
        content: "feat: Tối ưu luồng xử lý nghiệp vụ Ticket của luổng Call",
      },
    ],
    fix_bug: [
      {
        content: "fix: update sidebar app",
      },
      {
        content: "fix: show notifi not found droplist widget (BUCRM-2897)",
      },
      {
        content: "fix: load count total on pagination (BUCRM-1404)",
      },
      {
        content: "fix: add search select template modal record",
      },
    ],
  },
  {
    version: "3.15.0",
    create_day: "21/06/2024",
    new_feature: [
      {
        content:
          "feat: điều chỉnh luồng xử lý API submit form phiên bản key-value (UCRM-3307)",
      },
      {
        content: "feat: update multi parent droplist (UCRM-3343)",
      },
    ],
    fix_bug: [
      {
        content: "fix: [Kanban] add share record when edit record (BUCRM-2847)",
      },
      {
        content: "fix: [Workflow] handle search empty",
      },
    ],
  },
  {
    version: "3.14.0",
    create_day: "14/06/2024",
    new_feature: [
      {
        content:
          "feat: add sort and filter in Workflow, Dynamic button, Form setting (UCRM-3301)",
      },
      {
        content: "feat: [Kanban] integrate API calculate data and SLA",
      },
      {
        content: "feat: [Tenant] add contact birthday highlight (UCRM-3311)",
      },
    ],
    fix_bug: [
      {
        content: "fix: update limit select all droplist condition to 700",
      },
      {
        content: "fix: load data form contact call view (BUCRM-2834)",
      },
    ],
  },
  {
    version: "3.13.0",
    create_day: "06/06/2024",
    new_feature: [
      {
        content:
          "feat: bổ sung Standard Field để hiển thị thông tin cho tính năng Share to (UCRM-3305)",
      },
      {
        content: "feat: display hidden fields in settings (BUCRM-2738)",
      },
    ],
    fix_bug: [
      {
        content: "fix: save draft change value form interaction call view",
      },
    ],
  },
  {
    version: "3.12.0",
    create_day: "30/05/2024",
    new_feature: [
      {
        content:
          "feat: điều chỉnh cơ chế active và deactivate field (UCRM-3176)",
      },
      {
        content:
          "feat: cho phép điều chỉnh time range áp dụng cho all key trên custom report (UCRM-3238)",
      },
      {
        content:
          "feat: cơ chế chống submit form bằng tool đối với Internet Form (UCRM-3245)",
      },
      {
        content: "feat: add staging component",
      },
      {
        content:
          "feat: [Noti] allow on off audio and windows push noti (UCRM-3266)",
      },
      {
        content: "feat: [Kanban] new UI and feature (UCRM-3219)",
      },
      {
        content: "feat: [TimeRange] add dynamic range",
      },
    ],
    fix_bug: [
      {
        content: "fix: UI IC chat component on layout object",
      },
      {
        content: "fix: load dynamic field modal record consolidated view",
      },
      {
        content: "fix: clear cache obj field permission when CRUD field",
      },
      {
        content: "fix: blur UI timeline when zoom out browser",
      },
      {
        content:
          "fix: [CallCenter] clear data field type linking in Ticket list",
      },
      {
        content: "fix: [Workflow] add open new tab when click edit",
      },
    ],
  },
  {
    version: "3.11.0",
    create_day: "13/05/2024",
    new_feature: [
      {
        content: "feat: [Group] add import groups (UCRM-3225)",
      },
      {
        content:
          "feat: [Group] remove group option when create/edit group (UCRM-3230)",
      },
    ],
    fix_bug: [
      {
        content: "fix: [CallCenter] add loading when reload tab call",
      },
      {
        content: "fix: [CallCenter] flow reload tab",
      },
      {
        content: "fix: [CallCenter] clear data field type user in Ticket list",
      },
      {
        content: "Update env allow upload file",
      },
      {
        content: "fix: reload form contact call view",
      },
    ],
  },
  {
    version: "3.10.0",
    create_day: "07/05/2024",
    new_feature: [
      {
        content:
          "feat: thực hiện xây dựng màn hình quản lý Export/Import template tenant version 3 (UCRM - 3198)",
      },
      {
        content: "feat: display manual sharing (UCRM-3195)",
      },
      {
        content: "feat: consolidated view layout for objects (UCRM-3142)",
      },
      {
        content: "feat: add timeline component for object account",
      },
      {
        content: "feat: [Kanban] improve feat (UCRM-3150)",
      },
      {
        content: "feat: [VideoCall] integrate video call (UCRM-3191)",
      },
    ],
    fix_bug: [
      {
        content:
          "fix: [Internet Form] Lỗi cho phép người dùng submit internet form có field Rating = 0 (BUCRM-2705)",
      },
      {
        content: "fix: update limit for sending SMS (BUCRM-2690)",
      },
      {
        content: "fix: optimize load objects field permissions (UCRM-3213)",
      },
      {
        content:
          "fix: remove read-only field when creating and editing records (UCRM-3210)",
      },
      {
        content:
          "fix: [ICChatWidget] add disconnect and reconnect signalR; [InteractionForm] change UI",
      },
      {
        content: "fix: [Kanban] remove custom view",
      },
      {
        content: "fix: [CallCenter] duplicate third party ID (BUCRM-2682)",
      },
      {
        content: "fix: [Report] reset current page when change folder",
      },
      {
        content: "fix: [CallCenter] remove tab call",
      },
      {
        content: "fix: [CallCenter] reload tabcall",
      },
    ],
  },
  {
    version: "3.9.0",
    create_day: "12/04/2024",
    new_feature: [
      {
        content: "feat: [CallCenter] add disable multiple filters (UCRM-3179)",
      },
      {
        content:
          "feat: [CallCenter] add create contact, search contact in list contact (UCRM-3167)",
      },
      {
        content:
          "feat: [CallCenter] add action create manual record (UCRM-3137)",
      },
      {
        content: "feat: [Fields] add mode tags formula concat type",
      },
    ],
    fix_bug: [
      {
        content:
          "fix: case history hiển thị ID user trên Popup Call (BUCRM-2647)",
      },
      {
        content:
          "fix: [CallCenter] add create record core button in list contact (BUCRM-2638)",
      },
      {
        content: "fix: add update interaction when create in list contact",
      },
      {
        content: "fix: [SLA] format operator and value in new conditions",
      },
    ],
  },
  {
    version: "3.8.1",
    create_day: "05/04/2024",
    new_feature: [],
    fix_bug: [
      {
        content:
          "fix: fix display field in component case history (BUCRM-2064, BUCRM-2065)",
      },
      {
        content: "fix: save and reload data component multiDetail",
      },
      {
        content: "fix: load cache data droplist form interaction",
      },
      {
        content: "fix: update count select row on header table listview",
      },
    ],
  },
  {
    version: "3.8.0",
    create_day: "28/03/2024",
    new_feature: [
      {
        content:
          "feat: [CallCenter] Enable Same Inbound/Outbound Call Handling (UCRM-3123)",
      },
      {
        content:
          "feat: [CallCenter] add dynamic button to interaction form (UCRM-3019)",
      },
      {
        content:
          "feat: [CallCenter] add search in list transfer; [AgentMonitor] add list search status",
      },
      {
        content:
          "feat: bổ sung tính năng template record trong form interaction của màn hình popup call (UCRM-3132)",
      },
      {
        content: "feat: add Case history (UCRM-3067)",
      },
    ],
    fix_bug: [
      {
        content: "fix: [CallCenter] change result search core to each tab",
      },
      {
        content: "fix: [Report] add quick fillter when change page",
      },
      {
        content: "fix: notifi not found droplist popup URL (BUCRM-2567)",
      },
      {
        content: "fix: loading listview",
      },
    ],
  },
  {
    version: "3.7.1",
    create_day: "21/03/2024",
    new_feature: [],
    fix_bug: [
      {
        content: "fix: [RuleIncoming] add search fields",
      },
      {
        content: "fix: [AgentStatus] add color in agent monitor (BUCRM-2550)",
      },
      {
        content: "fix: field linking form interaction call view",
      },
      {
        content: "fix: field select dependency form interaction call view",
      },
      {
        content: "fix: field Droplist modal record URL Popup (BUCRM-2562)",
      },
    ],
  },
  {
    version: "3.7.0",
    create_day: "14/03/2024",
    new_feature: [
      {
        content: "feat: [ExposeAPI] add new token (UCRM-2923)",
      },
      {
        content: "feat: [AgentStatus] add mark default (UCRM-2937)",
      },
      {
        content: "feat: [EmailTemplate] add sender name (UCRM-2995)",
      },
      {
        content:
          "feat: [Email] add config to allow remove space before signature (UCRM-3001)",
      },
      {
        content: "feat: add button reload form interaction call",
      },
    ],
    fix_bug: [
      {
        content: "fix: [CallCenter] link interaction after duplicate record",
      },
      {
        content: "fix: [IC Integration] remove disabled Is IC Used",
      },
      {
        content: "fix condition can not change value",
      },
      {
        content: "fix: performance table listview",
      },
      {
        content: "fix: picklist dependency form interaction call",
      },
      {
        content: "fix: err 500 search quick linkingObject",
      },
    ],
  },
  {
    version: "3.6.0",
    create_day: "07/03/2024",
    new_feature: [
      {
        content: "feat: add droplist external app",
      },
      {
        content: "add notifi not found droplist report [UCRM-2961]",
      },
    ],
    fix_bug: [
      {
        content: "fix: field linking modal tiket call view",
      },
      {
        content: "add new ui quick linking",
      },
      {
        content: "fix: [CallCenter] width template 1",
      },
    ],
  },
  {
    version: "3.5.0",
    create_day: "01/03/2024",
    new_feature: [
      {
        content:
          "feat: [Picklist] Bổ sung Picklist vào trong Form Internet (UCRM-2929)",
      },
      {
        content: "feat: add quick choose field linking object (UCRM-2905)",
      },
    ],
    fix_bug: [
      {
        content: "fix: [CallCenter] clear chat IC (BUCRM-2420)",
      },
      {
        content: "fix: [CallCenter] sort content IC chat (BUCRM-2420)",
      },
    ],
  },
  {
    version: "3.4.0",
    create_day: "23/02/2024",
    new_feature: [
      {
        content:
          "feat: [ICIntegration] add check contact by social id (UCRM-2885)",
      },
      {
        content:
          "feat: [Report] display droplist type in conditions (BUCRM-2457)",
      },
      {
        content: "feat: add droplist expose and emailcoming",
      },
      {
        content: "feat: show droplist on log component",
      },
    ],
    fix_bug: [
      {
        content: "fix: [ModalRecord] add objectID when upload file",
      },
      {
        content:
          "fix: [Setting] add custom admin for Expose API Interaction and Apps Integration",
      },
      {
        content: "fix: [TicketList] add validate (BUCRM-2410)",
      },
      {
        content: "fix: [CallCenter] change full name (BUCRM-2414)",
      },
      {
        content:
          "fix: [CriteriaSharing] display name of droplist type (BUCRM-2443)",
      },
      {
        content: "fix: [RuleIncoming] crash rule incoming when change page",
      },
      {
        content: "fix: settings droplist",
      },
      {
        content: "fix: bug delete field droplist form workflow",
      },
      {
        content: "fix: delete and change droplist muti component",
      },
      {
        content: "fix: disable droplist when create field",
      },
      {
        content: "fix: default value droplist call view",
      },
      {
        content: "fix: show name field droplist create expose",
      },
      {
        content: "fix: delete field droplist on rule coming (email)",
      },
      {
        content: "fix: render list file on list view",
      },
    ],
  },
  {
    version: "3.3.0",
    create_day: "01/02/2024",
    new_feature: [
      {
        content: "feat: Generate ID (ucrm2739)",
      },
    ],
    fix_bug: [
      {
        content: "fix: [CriteriaSharing] display name owner (BUCRM-2354)",
      },
      {
        content: "fix: allow duplicate KB",
      },
      {
        content: "fix: bucrm 2392 post fix must not contain letters",
      },
      {
        content:
          "fix: ucrm2391, ucrm2390, ucrm2389, ucrm2387, ucrm2386, ucrm2385, ucrm2383, ucrm2382, ucrm2381",
      },
      {
        content:
          "fix: ucrm2391, ucrm2390, ucrm2389, ucrm2387, ucrm2386, ucrm2385, ucrm2383, ucrm2382, ucrm2381",
      },
    ],
  },
  {
    version: "3.2.2",
    create_day: "26/01/2024",
    new_feature: [
      {
        content: "feat: change click to call behavior (UCRM-2751)",
      },
    ],
    fix_bug: [
      {
        content: "fix: add time db formfieldObject",
      },
      {
        content: "fix: fix update type user (Callview)",
      },
      {
        content: "Update item Object sidebar",
      },
      {
        content: "fix: [URLPopup] add time db load record data",
      },
    ],
  },
  {
    version: "3.2.1",
    create_day: "18/01/2023",
    new_feature: [],
    fix_bug: [
      {
        content:
          "fix: [URLPopup] add modal duplicate rule when select record many params",
      },
      {
        content: "fix: [URLPopup] empty value params",
      },
      {
        content: "fix: [URLPopup] payload date and datetime",
      },
    ],
  },
  {
    version: "3.2.0",
    create_day: "12/01/2023",
    new_feature: [
      {
        content: "feat: Action logs (UCRM-2598)",
      },
      {
        content: "feat: Token Management (UCRM-2635)",
      },
      {
        content:
          "feat: [Workflow] add field created b y and modified by in actions (UCRM-2745)",
      },
    ],
    fix_bug: [],
  },
  {
    version: "3.1.0",
    create_day: "08/01/2023",
    new_feature: [
      {
        content: "feat: [URLPopup] add multi params (UCRM-2713)",
      },
    ],
    fix_bug: [
      {
        content: "fix: [Consolidatedview] 50% table 3rd",
      },
      {
        content: "fix: [URL Popup] allow global search many params",
      },
      {
        content: "fix: [CallCenter] reload data call",
      },
    ],
  },
  {
    version: "3.0.9",
    create_day: "04/01/2023",
    new_feature: [
      {
        content:
          "feat: phát triển chức năng cho phép cảnh báo khi tắt đóng trình duyệt khi soạn bài KB (UCRM-1661)",
      },
      {
        content: "feat: nhận biết bài viết có chỉnh sửa (UCRM-1673)",
      },
      {
        content: "feat: autosave in knowledge base (UCRM-2547)",
      },
      {
        content:
          "feat: [CallCenter] add create ticket in Ticket List; add duplicate rule",
      },
      {
        content: "feat: [URLPopup] add global search url (UCRM-2659)",
      },
      {
        content:
          "feat: [ExternalAppIntegration] allow input in select type (UCRM-2647)",
      },
    ],
    fix_bug: [
      {
        content:
          "fix: kết quả search không ăn theo filter của custom view (BUCRM-2264)",
      },
      {
        content: "fix: 50% table 3rd",
      },
    ],
  },
  {
    version: "3.0.8",
    create_day: "26/12/2023",
    new_feature: [
      {
        content:
          "feat: [CallCenter] create ticket in form interaction (UCRM-2592)",
      },
      {
        content: "feat: [ConsolidatedView] add component Search Contact",
      },
      {
        content: "feat: [CallCenter] add Ticket list component",
      },
      {
        content: "feat: [Workflow] add condition field type ID",
      },
    ],
    fix_bug: [
      {
        content: "fix double tap to open duplicated",
      },
      {
        content: "fix: [CallCenter] add 3rd comp, sort tab comp, UI",
      },
      {
        content:
          "fix: auto reload when update component detail, multi detail (BUCRM-2257)",
      },
      {
        content: "fix: [Email] replyall with many to (BUCRM-2259)",
      },
      {
        content: "fix: [CallCenter] update interaction one time",
      },
      {
        content:
          "fix: [CallCenter] add is_multiple_contact updateInteraction API",
      },
      {
        content: "fix: bug setting Tab template call",
      },
      {
        content: "fix: disabled edit tabs auto create",
      },
    ],
  },
  {
    version: "3.0.7",
    create_day: "19/12/2023",
    new_feature: [
      {
        content: "feat: add url popup prefix",
      },
    ],
    fix_bug: [
      {
        content: "fix: edit record listview (BUCRM-2240)",
      },
      {
        content: "fix: bug ticket form interaction (BUCRM-2239)",
      },
    ],
  },
  {
    version: "3.0.6",
    create_day: "14/12/2023",
    new_feature: [
      {
        content:
          "feat: [ExposeAPIInteraction] add expose API interaction (UCRM-2306)",
      },
    ],
    fix_bug: [
      {
        content: "fix: [CallCenter] add modal duplicate with 3rd",
      },
    ],
  },
  {
    version: "3.0.5",
    create_day: "07/12/2023",
    new_feature: [
      {
        content: "feat: add iframe component (UCRM-2341)",
      },
    ],
    fix_bug: [
      {
        content: "fix: bug picklist interaction - call view [BUCRM-2195]",
      },
    ],
  },
  {
    version: "3.0.4",
    create_day: "01/12/2023",
    new_feature: [],
    fix_bug: [
      {
        content: "fix bug load linking object",
      },
    ],
  },
  {
    version: "3.0.3",
    create_day: "23/10/2023",
    new_feature: [
      {
        content: "feat: update new table listview (UCRM-1769)",
      },
      {
        content: "feat: update new sidebar and header (UCRM-2288)",
      },
    ],
    fix_bug: [],
  },
  {
    version: "3.0.2",
    create_day: "16/10/2023",
    new_feature: [
      {
        content: "feat: add button check for update (UCRM-2230)",
      },
      {
        content:
          "feat: not Allow Admin to remove Standard Object và Standard Fields (UCRM-2217)",
      },
    ],
    fix_bug: [
      {
        content:
          "fix: not allow edit field readonly and formula in component multi-detail (BUCRM-2130)",
      },
    ],
  },
  {
    version: "3.0.0",
    create_day: "12/10/2023",
    new_feature: [
      {
        content: "- New Call Center",
      },
      {
        content: "- Standard object",
      },
      {
        content: "- New component for consolidated view and call center screen",
      },
    ],
    fix_bug: [],
  },
  {
    version: "2.73.0",
    create_day: "21/03/2024",
    new_feature: [
      {
        content:
          "feat: [Email] add config to allow remove space before signature (UCRM-3001)",
      },
      {
        content: "feat: [Email] add default to, cc, bcc in template email",
      },
    ],
    fix_bug: [
      {
        content:
          "fix: [Conditions] can not save condition when select not today",
      },
    ],
  },
  {
    version: "2.72.1",
    create_day: "14/03/2024",
    new_feature: [],
    fix_bug: [
      {
        content: "fix: [Workflow] 500 action related record",
      },
      {
        content: "fix: [Email] clean email content (BUCRM-2513)",
      },
      {
        content:
          "fix: [Sacombank] Điều chỉnh lại phân quyền Import của Object (BUCRM-2527)",
      },
      {
        content:
          "fix: fix field required in component muiltidetail, detail ver3 (BUCRM-2512)",
      },
      {
        content: "fix: fix edit picklist in multiple details",
      },
      {
        content: "fix: BUCRM-2524 fix required linking",
      },
    ],
  },
  {
    version: "2.72.0",
    create_day: "7/03/2024",
    new_feature: [
      {
        content: "feat: [ActionWorkflow] add new conditions (UCRM-2899)",
      },
      {
        content: "feat: [CallCenter] add prefix adjustment (UCRM-2989)",
      },
      {
        content:
          "feat: [Filter Condition] Áp dụng Condition mới trong Duplicate Rules (UCRM-2949)",
      },
    ],
    fix_bug: [
      {
        content:
          "fix: [Conditions] remove label key in new conditions (BUCRM-2479)",
      },
      {
        content: "fix: [SLA] add new conditions (UCRM-2893)",
      },
      {
        content: "fix: [SLA] delete conditions crash (BUCRM-2498)",
      },
    ],
  },
  {
    version: "2.71.0",
    create_day: "1/03/2024",
    new_feature: [
      {
        content:
          "feat: [Filter Condition] Áp dụng Condition mới trong Consolidated View - Tag/ Table Components",
      },
    ],
    fix_bug: [
      {
        content: "fix: [CriteriaSharing] display username in conditions",
      },
      {
        content:
          "fix: [CriteriaSharing] add new layout conditions (BUCRM-2470)",
      },
      {
        content: "fix: [Report] height of old conditions (BUCRM-2469)",
      },
    ],
  },

  {
    version: "2.70.0",
    create_day: "23/02/2024",
    new_feature: [
      {
        content: "feat: [Report] add new conditions Row Summary (UCRM-2605)",
      },
      {
        content:
          "feat: [ReportDetails] add new conditions in quick filters (UCRM-2629)",
      },
      {
        content: "feat: [CriteriaSharing] add new conditions (UCRM-2832)",
      },
    ],
    fix_bug: [
      {
        content:
          "fix: [Filter Conditions] Thêm chữ OR giữa 2 group AND (UCRM-2338)",
      },
      {
        content: "fix: [Finesse] change display name",
      },
      {
        content: "fix: [Email] rewrite func replace ref",
      },
    ],
  },
  {
    version: "2.69.0",
    create_day: "01/02/2024",
    new_feature: [],
    fix_bug: [
      {
        content: " fix: Allow to update field name to null bug (BUCRM-2401)",
      },
    ],
  },
  {
    version: "2.68.1",
    create_day: "26/01/2024",
    new_feature: [
      {
        content: "feat: [Report] add export report schedule (UCRM-2541)",
      },
    ],
    fix_bug: [
      {
        content: "fix: [Report] add required display name (BUCRM-2336)",
      },
      {
        content: "fix: [ExportReport] add default value end after (BUCRM-2344)",
      },
      {
        content: "fix: [Report] change pagi share report (BUCRM-2345)",
      },
      {
        content: "fix: [AssignmentRule] change status agent to array",
      },
      {
        content: "fix: [Email] 500 ref email",
      },
    ],
  },
  {
    version: "2.68.0",
    create_day: "18/01/2024",
    new_feature: [
      {
        content:
          "feat: [CallCenter] add minimize numpad when answered (UCRM-2535)",
      },
      {
        content: "feat: [TimeRange] add limit timerange (UCRM-2758)",
      },
      {
        content:
          "feat: new condition in Workflow, Dynamic Button, Listview (UCRM-2393)",
      },
      {
        content: "feat: new condition in custom report (UCRM-2605)",
      },
    ],
    fix_bug: [
      {
        content:
          "fix: [TimeRange] allow select to and from same day (BUCRM-2256)",
      },
      {
        content: "fix: [ReportDetails] Display empty conditions",
      },
    ],
  },
  {
    version: "2.67.0",
    create_day: "05/01/2024",
    new_feature: [
      {
        content: "feat: new condition in report and widget (UCRM-2547)",
      },
    ],
    fix_bug: [
      {
        content: "fix: add code voice biometric failed",
      },
      {
        content: "fix: add url popup prefix",
      },
      {
        content:
          "fix: kết quả search không ăn theo filter của custom view (BUCRM-2264)",
      },
      {
        content: "fix: auto reload data in component detail (BUCRM-2257)",
      },
    ],
  },
  {
    version: "2.66.0",
    create_day: "14/12/2023",
    new_feature: [
      {
        content:
          "feat: new condition in assignment rule and approval process (UCRM-2269)",
      },
    ],
    fix_bug: [
      {
        content: "fix: [Comment] add space before br tag (BUCRM-1940)",
      },
      {
        content:
          "fix: [IC Integration] reset token IC after add to form (BUCRM-1989)",
      },
      {
        content: "fix: bucrm 2196 fix bug all include-exclude condition",
      },
    ],
  },
  {
    version: "2.65.0",
    create_day: "07/12/2023",
    new_feature: [
      {
        content: "feat: Knowledge base type document (UCRM-2329)",
      },
    ],
    fix_bug: [
      {
        content: "fix: change payload attach files forward mail (BUCRM-2188)",
      },
      {
        content: "fix: fix bug condition",
      },
      {
        content: "fix: update SSO 2.3",
      },
    ],
  },

  {
    version: "2.64.0",
    create_day: "01/12/2023",
    new_feature: [
      {
        content: "feat: improvement internet form (UCRM-2497)",
      },
      {
        content: "feat: ucrm 2282 ex/include for type user linking lookup",
      },
    ],
    fix_bug: [
      {
        content:
          "fix: [ReportDetails] add display condition is one of (BUCRM-2176)",
      },
      {
        content:
          "fix: [Comment] load reply comment after sort comment (BUCRM-1851)",
      },
      {
        content: "fix: reload table when add new record Bucrm-2173",
      },
      {
        content: "fix: bucrm 2171 clear value when select date",
      },
    ],
  },
  {
    version: "2.63.0",
    create_day: "23/11/2023",
    new_feature: [
      {
        content: "feat: Filter condition in/exclude (UCRM-2263)",
      },
      {
        content: "feat: Improvement custom report (UCRM-2186)",
      },
      {
        content: "feat: Improvement UI knowledge base type blog (UCRM-1667)",
      },
    ],
    fix_bug: [
      {
        content: "fix: [Report] duplicate field ID chart (BUCRM-2145)",
      },
      {
        content: "fix: default value (BUCRM-2157)",
      },
    ],
  },
  {
    version: "2.62.0",
    create_day: "16/11/2023",
    new_feature: [
      {
        content: "feat: [Report] add row summary report type (UCRM-2180)",
      },
      {
        content: "feat: [Email] change attach files to file label (UCRM-2249)",
      },
    ],
    fix_bug: [],
  },
  {
    version: "2.61.0",
    create_day: "13/11/2023",
    new_feature: [
      {
        content: "feat: Allow setting current time in min max value",
      },
    ],
    fix_bug: [],
  },
  {
    version: "2.60.0",
    create_day: "10/11/2023",
    new_feature: [
      {
        content:
          "feat: bổ sung min/max cho trường ngày tháng và trường number ở form Internet (UCRM-2237)",
      },
      {
        content:
          "feat: on/off cho phép search ở field select ở form internet (UCRM-2243)",
      },
    ],
    fix_bug: [],
  },
  {
    version: "2.59.0",
    create_day: "2/11/2023",
    new_feature: [
      {
        content: "feat: allow to setup soft required in field setting",
      },
      {
        content: "feat: export agent status",
      },
      {
        content: "feat: [Tenant] add API change pass root",
      },
      {
        content: "feat: [LDAP] allow to login with Alias",
      },
    ],
    fix_bug: [
      {
        content: "fix: datetime local in internet form",
      },
      {
        content: "fix: update refresh token",
      },
      {
        content: "fix: [Noti] change navigate view logs",
      },
    ],
  },
  {
    version: "2.58.0",
    create_day: "26/10/2023",
    new_feature: [
      {
        content: "feat: allow sort form in internet form (UCRM-1980)",
      },
      {
        content: "feat: mask value input in internet form (UCRM-2018)",
      },
      {
        content: "feat: format value number in internet form (UCRM-2024)",
      },
      {
        content:
          "feat: [DateTimeSetting] allow tenant to setup working hours and holidays (UCRM-2063)",
      },
      {
        content: "feat: [AssignmentRule] add working time (UCRM-2075)",
      },
      {
        content:
          "feat: [AssignmentRule] allow to set the maximum number (UCRM-2081)",
      },
      {
        content: "feat: [Report] allow user save quick filter (UCRM-2006)",
      },
      {
        content:
          "feat: [Workflow] allow to use selected value of triggered record (UCRM-2095)",
      },
      {
        content:
          "feat: [Workflow] allow to use field ID and Assign To in Create record and Update Related Source (UCRM-2138)",
      },
      {
        content:
          "feat: ucrm-2069 [Workflow] Condition to check if the created date or modified time",
      },
      {
        content:
          "feat: uCRM-2087 Tính năng merge Contact theo mô hình standard Object",
      },
    ],
    fix_bug: [
      {
        content: "fix: bucrm 2056 formula field in condition",
      },
      {
        content: "fix inword in date diff",
      },
    ],
  },
  {
    version: "2.57.3",
    create_day: "12/10/2023",
    new_feature: [],
    fix_bug: [
      {
        content: "fix: [VoiceBiometric] call voice authen one time",
      },
      {
        content: " fix: [VoiceBiometric] add agent name",
      },
      {
        content: " fix: Template 500",
      },
      {
        content: " fix: Default picklist",
      },
    ],
  },
  {
    version: "2.57.2",
    create_day: "06/10/2023",
    new_feature: [],
    fix_bug: [
      {
        content: "fix: security issues with payload API Bucrm-1970",
      },
    ],
  },
  {
    version: "2.57.1",
    create_day: "21/09/2023",
    new_feature: [
      {
        content:
          "feat: allow setting default value for internet form (UCRM-1938)",
      },
    ],
    fix_bug: [
      {
        content: "fix: can not submit form Bucrm-1909",
      },
      {
        content: "fix: pagination in form setting (UCRM-1925)",
      },
    ],
  },
  {
    version: "2.57.0",
    create_day: "14/09/2023",
    new_feature: [
      {
        content:
          "feat: allow setting default value for internet form (UCRM-1938)",
      },
      {
        content: "feat: save IP address of customer submit form (UCRM-1944)",
      },
      {
        content: "feat: allow delete tenants (UCRM-1962)",
      },
      {
        content: "feat: add or conditions in SLA (UCRM-2000)",
      },
    ],
    fix_bug: [
      {
        content: "hidden owner on chat IC QM view (BUCRM 1775)",
      },
      {
        content: "fix: fix 500 when mass edit field editor (UCRM-1897)",
      },
    ],
  },
  {
    version: "2.56.0",
    create_day: "31/8/2023",
    new_feature: [
      {
        content: "feat: [Internet form] Allow pagination in internet form",
      },
      {
        content: "feat: Add owa type outgoing email setting (UCRM 1851)",
      },
    ],
    fix_bug: [],
  },
  {
    version: "2.55.0",
    create_day: "24/8/2023",
    new_feature: [
      {
        content:
          "feat: [DynamicButton] Add select, date, datetime in modal udpate fields (UCRM-1739)",
      },
      {
        content:
          "feat: [URLPopup] allow add multiple param in URL popup (UCRM-1906)",
      },
      {
        content: "feat: [Comments] add sort comments (UCRM-1763)",
      },
      {
        content:
          "feat: [Dynamic button] add Triggered User in action Create/Update/Call API (UCRM-1745)",
      },
      {
        content: "feat: add unit weekday type dateToParts (UCRM-1900)",
      },
      {
        content: "feat: add owa type (UCRM-1851)",
      },
    ],
    fix_bug: [
      {
        content:
          "fix: [Email] remove style css when parse in Editor (BUCRM-1744)",
      },
      {
        content: "fix: multiDetail crash page",
      },
      {
        content: "fix: [SLA] hide pending condition when deadline is active",
      },
      {
        content: "fix: date to parts allow get weekday (UCRM-1900)",
      },
      {
        content: "fix: cai thien temaplte record (UCRM-1733)",
      },
      {
        content: "fix: 500 when edit record (BUCRM-1840)",
      },
      {
        content: "fix: layout Comment QM View",
      },
    ],
  },
  {
    version: "2.54.0",
    create_day: "17/8/2023",
    new_feature: [
      {
        content:
          "feat: allow to increase/decrease field number when Update Source Record (UCRM-390)",
      },
      {
        content:
          "feat: allow display default value in form description (UCRM-1869)",
      },
      {
        content: "feat: allow generate link QR code in internet form",
      },
      {
        content: "feat: search in formula field",
      },
    ],
    fix_bug: [
      {
        content: "fix: remove redundant APIs get user (UCRM-1839)",
      },
      {
        content: "fix: [KB] add token media",
      },
      {
        content: "fix: show form type ThirdParty (QM)",
      },
    ],
  },
  {
    version: "2.53.0",
    create_day: "10/8/2023",
    new_feature: [
      {
        content: "feat: add knowledge in left-right component",
      },
      {
        content: "feat: add not today in report SLA and Campaign",
      },
      {
        content: "feat: add option use fixed Deadline on Rules",
      },
    ],
    fix_bug: [
      {
        content: "fix: update search in knowledge base",
      },
      {
        content: "fix: add authen file",
      },
      {
        content: "fix: [IC Integration] reset value after change object",
      },
      {
        content:
          "fix: [Modal Record] remove empty tag editor field when update record",
      },
      {
        content: "fix: [Modal interaction] overflow UI body email",
      },
      {
        content: "fix: [Modal record] error when upload file in call and table",
      },
      {
        content: "fix: [IC Integration] call API advanced config",
      },
      {
        content: "fix: permission QM",
      },
      {
        content: "fix: permission quickfilter QM",
      },
      {
        content: "fix: default custom view QM",
      },
      {
        content: "fix: add button scroll quickFilter and style details info IC",
      },
    ],
  },
  {
    version: "2.52.0",
    create_day: "3/8/2023",
    new_feature: [
      {
        content: "[Email] allow config on off overwrite subject",
      },
      {
        content: "Allow config clone tenant",
      },
      {
        content: "Search knowledge base with ID",
      },
    ],
    fix_bug: [
      {
        content: "fix: [Report] set color chart",
      },
      {
        content: "fix: add check condition when call API load form create",
      },
      {
        content: "fix: Layout chat ic QM ",
      },
      {
        content: "fix: additional not today in condition",
      },
    ],
  },
  {
    version: "2.51.0",
    create_day: "27/7/2023",
    new_feature: [
      {
        content: "Quality management",
      },
      {
        content: "Custom report",
      },
      {
        content: "Add default alias config",
      },
    ],
    fix_bug: [
      {
        content: "Fix dư dấu / trong API get-users-detail",
      },
      {
        content: "Fix mất field linking khi sử dụng template record",
      },
      {
        content: "Fix allow to change report folder",
      },
    ],
  },
  {
    version: "2.50.0",
    create_day: "20/7/2023",
    new_feature: [],
    fix_bug: [
      {
        content: "Update Modal Assignment Rule",
      },
      {
        content: "Add user when select another record",
      },
      {
        content: "Add default search type call Finesse",
      },
    ],
  },
  {
    version: "2.49.1",
    create_day: "13/7/2023",
    new_feature: [],
    fix_bug: [
      {
        content: "fix: [Email] white space ",
      },
      {
        content: "fix: [Numpad] show disconnect btn when dynamic ext; ",
      },
      {
        content: "fix: parse HTML in component detail, multi-detail, tags",
      },
    ],
  },
  {
    version: "2.49.0",
    create_day: "6/7/2023",
    new_feature: [
      { content: "[Finesse] Allow users to share extension" },
      { content: "Capcha in internet form" },
      { content: "Format only number in internet form" },
      { content: "Allow setting uppercase and lowercase in internet form" },
      { content: "Monitoring" },
    ],
    fix_bug: [
      {
        content:
          "fix: [Interaction Settings] allow user edit interaction settings ",
      },
      {
        content: "Fix Authentication type",
      },
      {
        content: "Fix template record when edit",
      },
    ],
  },
  {
    version: "2.48.0",
    create_day: "27/6/2023",
    new_feature: [{ content: "Improvement search in listview" }],
    fix_bug: [
      {
        content: "fix: add clone config email [Root]",
      },
      {
        content: "Allow update Interaction setting",
      },
    ],
  },
  {
    version: "2.47.0",
    create_day: "22/6/2023",
    new_feature: [
      { content: "Allow to attach file in Internet Form" },
      { content: " Add Email config in Root" },
      { content: "Object standard" },
    ],
    fix_bug: [
      {
        content: "fix: (CTI) add generate Token C247",
      },
    ],
  },
  {
    version: "2.46.1",
    create_day: "16/6/2023",
    new_feature: [],
    fix_bug: [
      {
        content: "Hot fix FE version 2.46.0",
      },
    ],
  },
  {
    version: "2.46.0",
    create_day: "13/6/2023",
    new_feature: [
      { content: "Allow to set required field in Form " },
      { content: "Apply grading in internet form" },
      {
        content:
          "[SLA] Allow to set Action for each Alert Milestone and Overdue SLA",
      },
      { content: "[Workflow] add trigger when popup" },
    ],
    fix_bug: [
      {
        content: "fix: issue Cross-Site Scripting",
      },
      {
        content: "fix: hide encrypted fields in some features",
      },
      {
        content: "fix: limit user's information in API",
      },
      { content: "fix: add API run index in root" },
      { content: "fix: [PopupURL] add API check workflow" },
      { content: "fix: add lineHeight editor" },
      {
        content: "fix: add ask before paste html Editor",
      },
    ],
  },
  {
    version: "2.45.3",
    create_day: "1/6/2023",
    new_feature: [],
    fix_bug: [
      {
        content: "Color in QR code",
      },
      {
        content:
          "fix: Allow update display_status_options in knowledge base setting",
      },
      {
        content: "fix: Delete showtime in article",
      },
    ],
  },
  {
    version: "2.45.2",
    create_day: "29/5/2023",
    new_feature: [],
    fix_bug: [
      {
        content: "fix: Crash comment",
      },
      {
        content: "fix: [Email] Allow copy table from excel",
      },
    ],
  },
  {
    version: "2.45.1",
    create_day: "25/5/2023",
    new_feature: [
      {
        content: "Editor with field textarea",
      },
      {
        content:
          "[Dynamic Button - Update Field] Load old data; required; text editor",
      },
    ],
    fix_bug: [],
  },
  {
    version: "2.45.0",
    create_day: "23/5/2023",
    new_feature: [
      {
        content: "[VoiceBiometric] Add outgoing call",
      },
    ],
    fix_bug: [
      {
        content: "fix: [Report] Edit value fields chart",
      },
      {
        content: "fix: Protect from cross-site scripting attacks",
      },
      {
        content: "fix: IC chat widget SSO",
      },
      {
        content: "fix: Time range in modal component",
      },
      {
        content: "fix: [Email] Allow change subject when reply, forward email",
      },
    ],
  },
  {
    version: "2.44.1",
    create_day: "19/5/2023",
    new_feature: [
      {
        content: "Allow clone customview.",
      },
      {
        content: "Add time range in custom view, component tags, table ",
      },
      {
        content: "Template file",
      },
      {
        content: "[Report] Add horizontal bar, funnel chart; details pie chart",
      },
    ],
    fix_bug: [
      {
        content: "Fix get token IC SSO",
      },
      {
        content: "Fix security",
      },
    ],
  },
  {
    version: "2.44.0",
    create_day: "15/5/2023",
    new_feature: [
      {
        content: "Allow admin to setup dynamic field for a form.",
      },
      {
        content: "[URL Popup] Add param to modal create record",
      },
    ],
    fix_bug: [
      {
        content: "Authen in Expose API Check",
      },
      {
        content: "Validate field phone number in internet form",
      },
    ],
  },
  {
    version: "2.43.0",
    create_day: "9/5/2023",
    new_feature: [
      {
        content:
          "[Dynamic Button] Allow Admin to setup which fields User can update manually when clicking a Dynamic Button.",
      },
      {
        content:
          "[Workflow Action] Link Assign to của Interaction đến User trong Object User (standard Object)",
      },
      {
        content:
          "Lấy các metadata liên quan đến QM cho các Interaction từ Calabiro",
      },
      {
        content:
          "Allow Root Admin to config Custom Admin Setting or turn off Admin Permission of a Tenant",
      },
      {
        content: "Integrate with C247 Cloud",
      },
      {
        content: "Add external QR for internet form",
      },
    ],
    fix_bug: [
      {
        content: "Fix filter core 3rd third party",
      },
    ],
  },
  {
    version: "2.42.1",
    create_day: "18/4/2023",
    new_feature: [],
    fix_bug: [
      {
        content: "Fix length of file in table",
      },
      {
        content: "Add new field into interaction setting",
      },
      {
        content: "Add identify phone prefix ",
      },
    ],
  },
  {
    version: "2.42.0",
    create_day: "13/4/2023",
    new_feature: [],
    fix_bug: [
      {
        content: "Fix date format in consolidated view",
      },
    ],
  },
  {
    version: "2.41.0",
    create_day: "6/4/2023",
    new_feature: [
      { content: "Allow to copy html text from Email body" },
      { content: "Allow to set shared custom view as default" },
    ],
    fix_bug: [
      {
        content: "Update UI third party in consolidated view",
      },
      {
        content: "Add new timeline into listview with details",
      },
      {
        content: "Fix SSO auto reload page",
      },
    ],
  },
  {
    version: "2.40.2",
    create_day: "29/3/2023",
    new_feature: [],
    fix_bug: [
      {
        content: "Add loading when search core",
      },
      {
        content: "Change button switch",
      },
      {
        content: "Add encrypted field",
      },
      {
        content: "[Call Center] Fix overwrite data call",
      },
    ],
  },
  {
    version: "2.40.0",
    create_day: "21/3/2023",
    new_feature: [],
    fix_bug: [
      {
        content: "fix: [Interaction Setting] Add phone number",
      },
      {
        content: "fix: [CallCenter] Add search core",
      },
    ],
  },
  {
    version: "2.39.0",
    create_day: "16/3/2023",
    new_feature: [
      {
        content: "Feature share custom view",
      },
    ],
    fix_bug: [
      {
        content: "Add show file type when upload",
      },
      {
        content: "Fix bug duplicate rules",
      },
      {
        content: "Fix number in consolidated view",
      },
    ],
  },
  {
    version: "2.38.2",
    create_day: "9/3/2023",
    new_feature: [],
    fix_bug: [
      {
        content: "[Interaction Email] Add body",
      },
      {
        content: "[TabComponent] Add drag",
      },
      {
        content: "Fix detail third party and with detail",
      },
      {
        content: "Update with detail and detail third party",
      },
    ],
  },
  {
    version: "2.38.1",
    create_day: "6/3/2023",
    new_feature: [],
    fix_bug: [
      {
        content:
          "[IC Chat Widget] Add loading when upload file; Send comment, file viber",
      },
      {
        content: "Fix multi details",
      },
      {
        content: "Fix decimals number",
      },
      {
        content: "Improvement consolidated view",
      },
      {
        content: "[IC Chat Widget] Add type email and comment, send voice",
      },
      {
        content: "[IC Chat Widget] Add type email and comment, send voice",
      },
    ],
  },
  {
    version: "2.38.0",
    create_day: "23/2/2023",
    new_feature: [
      {
        content: "Multi columns details",
      },
      {
        content: "Page title in consolidated view",
      },
      {
        content: "[VBEE] Add outgoing type",
      },
      {
        content: "[Callcenter] Add search global, add object click to call",
      },
    ],
    fix_bug: [
      {
        content: "Fix linking in table consolidated view",
      },
      {
        content: "Option number",
      },
      {
        content: "Fix decimals number",
      },
      {
        content: "[Agent Monitor] Get init status CRM",
      },
    ],
  },
  {
    version: "2.37.0",
    create_day: "17/2/2023",
    new_feature: [],
    fix_bug: [
      {
        content: "- Report details 500",
      },
      {
        content: "- Fix UI of component in Consolidated view",
      },
    ],
  },
  {
    version: "2.36.0",
    create_day: "15/2/2023",
    new_feature: [
      {
        content: "- Agent monitor",
      },
      {
        content: "- New interaction timeline",
      },
      {
        content: "- Login enhancment: Refresh token",
      },
      {
        content: "- Global search",
      },
      {
        content: "- New Knowledge Base",
      },
      {
        content: "- Refresh token External app intergration",
      },
      {
        content: "- Approval processes",
      },
      {
        content: "- IC Chat Widget",
      },
    ],
    fix_bug: [
      { content: "- DFI472: Lỗi linking field: Hiển thị sai records đã chọn" },
      {
        content: "- DFI469: SLA không có thông báo khi gần quá hạn và quá hạn",
      },
      { content: "- DFI422: Lỗi không serach được assign to khi tạo view" },
      { content: "- DFI420: Lỗi khi edit trong màn hình consolidated view" },
      {
        content:
          "- DFI389: Không Edit Picklist Dependency trong Consolidated view.",
      },
      { content: "- fix: [Finesse integration] Add default holine" },
      { content: "- fix: [Action workflow] Add today +- n" },
      { content: "- fix: Add decimal separator" },
      { content: "- fix: hot fix logout" },
    ],
  },
  {
    version: "2.35.0",
    create_day: "17/1/2023",
    new_feature: [
      {
        content: "- [Expose API] Add expose API view, upload, delete file",
      },
    ],
    fix_bug: [
      {
        content: "- OTP Finesse, CTI, Voicebiometric, Internal app integration",
      },
      {
        content:
          "- Allow to set Success Milestone to a datetime field of a record which is matched SLA rule",
      },
      { content: "- Add SECRET KEY" },
      { content: "- Fix comp detail profile for table and tag" },
      { content: "- Add language for template select in duplicate" },
    ],
  },
  {
    version: "2.34.0",
    create_day: "10/1/2023",
    new_feature: [],
    fix_bug: [
      { content: "- Fix type linkingobject" },
      { content: "- Optimize search in listview and hot fix edit detail comp" },
      { content: "- Fix role profile for consolidated view tag comp" },
      { content: "- Fix create template record" },
      { content: "- Double click edit detail, UI SLA" },
    ],
  },
  {
    version: "2.33.0",
    create_day: "30/12/2022",
    new_feature: [
      {
        content: "- Create record template",
      },
      {
        content: "- Duplicate rule",
      },
    ],
    fix_bug: [{ content: "- [Popup contact] Fix two new phone number popup" }],
  },
  {
    version: "2.32.0",
    create_day: "27/12/2022",
    new_feature: [],
    fix_bug: [
      { content: "- [Email Signature] Allow show signature before quote" },
      { content: "- [Finesse] Hide password" },
      { content: "- [CTI] Add C247 Standard " },
    ],
  },
  {
    version: "2.30.1",
    create_day: "22/12/2022",
    new_feature: [],
    fix_bug: [
      { content: "- Delete draft email when have component Comments" },
      { content: "- Field type formula datediff in words" },
    ],
  },
  {
    version: "2.30.0",
    create_day: "19/12/2022",
    new_feature: [
      {
        content: "- Allow user copy paste image",
      },
      {
        content: "- Draft email",
      },
      {
        content: "- Embed Iframe",
      },
      {
        content: "- Add trigger workflow with interaction",
      },
    ],
    fix_bug: [
      { content: "- Call center create record" },
      { content: "- Auto delete last signature" },
      { content: "- Upload one image when copy" },
      {
        content: "- Default view",
      },
      { content: "- Delete keep filter in listview" },
      { content: "- Fix bug option dashboard" },
      {
        content:
          "- Fix linking filter and double click to edit detail in consolidated view",
      },
      { content: "- Upsize text and textarea length from 10000 to 100000" },
    ],
  },
  {
    version: "2.29.2",
    create_day: "15/12/2022",
    new_feature: [
      {
        content: "- Add copy paste list email when write email",
      },
    ],
    fix_bug: [
      { content: "- Add note version BE in Modal Version" },
      { content: "- Fix display report details" },
      { content: "- Fix search number in list view" },
      {
        content:
          "- Fix linking filter and double click to edit detail in consolidated view",
      },
      { content: "- Fix third party" },
    ],
  },
  {
    version: "2.29.1",
    create_day: "13/12/2022",
    new_feature: [
      {
        content: "- Draft Email",
      },
      {
        content: "- Email Signature",
      },
      {
        content: "- Embed Iframe",
      },
      {
        content: "- Add authentication type token in External app integration",
      },
    ],
    fix_bug: [
      { content: "- Add quick filter when export report" },
      { content: "- Fix duplicated rule" },
      { content: "- Only call event to check data when use Voice Biometric" },
    ],
  },
  {
    version: "2.28.0",
    create_day: "08/12/2022",
    new_feature: [
      {
        content: "- New Duplicate rule",
      },
      {
        content: "- Add report permission",
      },
      {
        content: "- Add permission for Export, Import, Report",
      },
    ],
    fix_bug: [
      { content: "- Add download image" },
      { content: "- Fix edit detail loading" },
      { content: "- Fix third party and duplicate rule" },
      { content: "- Update display listview" },
      {
        content:
          "- Improvement modal list view, edit, UI modal record, consolidated view",
      },
    ],
  },
  {
    version: "2.27.1",
    create_day: "29/11/2022",
    new_feature: [
      {
        content: "Nothing to update",
      },
    ],
    fix_bug: [
      { content: "- Update permission in Brand and Color" },
      { content: "- Fix empty description in Calendar" },
      { content: "- Add click notification show error email" },
      { content: "- Keep content of reply email" },
      { content: "- Update UI; Update logic Action on read" },
      { content: "- Add responsive chart" },
      { content: "- Fix UI detail component" },
      {
        content:
          "- Number in kanban view, detail consolidated view, trim list view",
      },
      { content: "- Add modal zoom image in comments component" },
      { content: "- Fix edit file upload in consolidated view" },
      { content: "- Add new editor" },
      { content: "- Unlock action update related target record" },
    ],
  },
  {
    version: "2.27.0",
    create_day: "24/11/2022",
    new_feature: [
      {
        content: "- Add button scan mail",
      },
    ],
    fix_bug: [
      { content: "- Select template do not replace subject" },
      { content: "- Update UI; Update logic Action on read" },
      {
        content:
          "- Add on fail, Add select picklist, Change linking type, New UI new logic, Type select in Rule incomming",
      },
    ],
  },
];
